import apiRequest from './apiRequest';
import type { AssetListResponse } from './getAssets';

export type GetAssetByIDParams = {
  /** User ID used to populate bookmark state on each asset. */
  requestedByUser?: string;
};

/** GET /assets/{assetID} — resolves a single asset or all assets in a group/batch. */
export default async function getAssetByID(
  apiKey: string,
  assetID: string,
  params: GetAssetByIDParams = {},
  signal?: AbortSignal,
) {
  const urlParams = new URLSearchParams();

  if (params.requestedByUser) {
    urlParams.set('requestedByUser', params.requestedByUser);
  }

  const query = urlParams.toString();

  return apiRequest<AssetListResponse>(
    'external-mogen',
    `/assets/${encodeURIComponent(assetID)}${query ? `?${query}` : ''}`,
    {
      method: 'GET',
      headers: {
        'x-api-key': apiKey,
      },
    },
    signal,
  );
}
